import {DecimalPipe, NgTemplateOutlet} from '@angular/common'
import {Component, computed, inject} from '@angular/core'
import {MatIconButton} from '@angular/material/button'
import {MatDialog} from '@angular/material/dialog'
import {MatIcon} from '@angular/material/icon'
import {MatTooltip} from '@angular/material/tooltip'
import {
  APPLICATION_ID,
  blancoHighestThreshold,
  TApplicationLogType,
  ucLowestThreshold
} from '@sparbanken-syd/loan-backend'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {LoanPromiseStatus} from '../../../services/loan-promise-status'
import {LoanService} from '../../../services/loan.service'
import {RoleHelper} from '../../../services/role-helper'
import {AddNotesDialogData, KalpAddNotesComponent} from '../kalp-add-notes/kalp-add-notes.component'

@Component({
  selector: 'spb-kalp-non-superfast-info',
  templateUrl: './kalp-non-superfast-info.component.html',
  styleUrls: ['./kalp-non-superfast-info.component.scss'],
  imports: [MatIcon, NgTemplateOutlet, MatTooltip, DecimalPipe, MatIconButton]
})
export class KalpNonSuperfastInfoComponent {
  public readonly loanService = inject(LoanService)
  public status = computed(() => {
    const app = this.loanService.application()
    return app ? new LoanPromiseStatus(app) : new LoanPromiseStatus({} as any)
  })

  public readonly helper = inject(RoleHelper)
  protected readonly configService = inject(ConfigService)
  protected readonly ucLowestThreshold = ucLowestThreshold
  protected readonly blancoHighestThreshold = blancoHighestThreshold

  private readonly dialog = inject(MatDialog)

  public openNotesDialog(type: TApplicationLogType) {
    const app = this.loanService.application()!
    const currentStatus = this.status()
    this.dialog.open<KalpAddNotesComponent, AddNotesDialogData, any>(KalpAddNotesComponent, {
      disableClose: true,
      data: {
        applicationId: app[APPLICATION_ID],
        logType: type,
        previousNotes: [],
        resolved: currentStatus.hasOverride(type)
      }
    })
  }
}
